import { render, staticRenderFns } from "./arquivos.vue?vue&type=template&id=9157f29c&scoped=true&"
import script from "./arquivos.vue?vue&type=script&lang=js&"
export * from "./arquivos.vue?vue&type=script&lang=js&"
import style0 from "./arquivos.vue?vue&type=style&index=0&id=9157f29c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9157f29c",
  null
  
)

export default component.exports